import { reportAccessSlice } from 'store/configuration/report-access/slices/report-access-slice';

export const configurationReportAccessReducer = reportAccessSlice.reducer;
